
function html2string(html){
    return html.replace(/<\/?.+?>/g,"").trim();
}

function scrollTopAnimation(target_el,parent_el,offset) {
    let scrolltopTemp = parent_el.scrollTop;
    let rect = target_el.getBoundingClientRect();
    // 获取元素相对窗口的top值，此处应加上页面本身的偏移
    let top = scrolltopTemp + rect.top + offset;
    let currentTop = scrolltopTemp;
    let requestId;

    let isTop = top > currentTop;

    function step () {
        if(isTop){
            currentTop += 30;
        }else{
            currentTop -= 30;
        }
        if ((isTop&&currentTop <= top)||(!isTop&&currentTop >= top)) {
            parent_el.scrollTo(0, currentTop);
            requestId = window.requestAnimationFrame(step);
        } else {
			parent_el.scrollTo(0, top);
            window.cancelAnimationFrame(requestId);
        }
    }
    window.requestAnimationFrame(step);
}

function sortQuestion(questionlist){
    let page = 1;
    let sort = 0;
    let result = [];
    for(let question of questionlist){
        if(question.questionsTypeId == 26){
            page = question.pageNumber
        }
        question.orders = ++sort;
        question.pageNumber = page;

        result.push({
            id:question.id,
            orders:sort,
            pageNumber:page
        })
    }
    return result; 
}

export default {
    html2string,
    scrollTopAnimation,
    sortQuestion
}